import React from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ListGroup from "react-bootstrap/ListGroup";
import NavBar from "../components/NavBar";
import "./checkout.css";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import axios from "axios";
import OrderModal from "./OrderModal";
import { removeCart } from "../Redux/shoppingCartSlice";
import { ToastContainer, toast } from "react-toastify";
import { useForm } from "react-hook-form";

function Checkout() {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const shoppingCart = useSelector((state) => state.shoppingCart);
  const totalPrice = shoppingCart
    .map((item) => Number(item.price) * item.quantity)
    .reduce((prev, curr) => prev + curr, 0);
  const [orderDetails, setOrderDetails] = useState({
    userId: user.id,
    total: totalPrice,
    product: shoppingCart,
  });

  const [newOrder, setNewOrder] = useState();
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  const onSubmit = async () => {
    setLoader(true);
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_URL_BACK}/user/checkout`,
      data: orderDetails,
    });
    setNewOrder(response.data);
    dispatch(removeCart());
    handleShow();

    setTimeout(() => {
      setLoader(false);
    }, 3000);
  };

  return (
    <>
      <NavBar />
      <div className="container">
        <div className="row order d-flex justify-content-evenly flex-wrap p-3">
          {/* detalles de facturacion */}
          <div className="col-10 col-lg-4 detalles p-4 border rounded-3 mb-4">
            <Form>
              <h3>Personal Information</h3>
              <hr />
              <Form.Group className="mb-3">
                <Form.Label>Firstname *</Form.Label>
                <Form.Control
                  className="text-muted"
                  type="text"
                  required="true"
                  value={user.firstName}
                  readOnly
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Lastname *</Form.Label>
                <Form.Control
                  type="text"
                  required="true"
                  value={user.lastName}
                  className="text-muted"
                  readOnly
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email *</Form.Label>
                <Form.Control
                  type="email"
                  required="true"
                  value={user.email}
                  className="text-muted"
                  readOnly
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Phone Number *</Form.Label>
                <Form.Control
                  type="number"
                  required="true"
                  value={user.phone}
                  className="text-muted"
                  readOnly
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Address *</Form.Label>
                <Form.Control
                  type="text"
                  required="true"
                  value={user.address}
                  className="text-muted"
                  readOnly
                />
              </Form.Group>
            </Form>
          </div>
          {/* metodo de pago */}
          <div className="col-10 col-lg-6 pago p-4 border rounded-3">
            <h3>Order Details</h3>
            <hr />

            {shoppingCart.map((item) => {
              return (
                <ListGroup className="mb-2" key={item.id}>
                  <ListGroup.Item>
                    <div>
                      <div className="d-flex justify-content-between">
                        <div>
                          <strong>
                            {item.name} x{item.quantity}
                          </strong>
                        </div>
                        <div>US$ {(item.price * item.quantity).toFixed(2)}</div>
                      </div>
                      <div>Unit price: US$ {item.price}</div>
                    </div>
                  </ListGroup.Item>
                </ListGroup>
              );
            })}

            <hr />
            <div className="d-flex justify-content-between mt-4">
              <h5 className="mt-2">Total</h5>
              <span className="fs-3">US$ {totalPrice.toFixed(2)}</span>
            </div>
            <hr />
            <div>
              <span>Select Payment Method</span>
              <Form className="mt-3 d-flex">
                <Form.Check className="me-2">
                  <Form.Check.Input />
                  <Form.Check.Label>
                    <i className="fa-brands fs-2 fa-cc-mastercard"></i>
                  </Form.Check.Label>
                </Form.Check>
                <Form.Check>
                  <Form.Check.Input />
                  <Form.Check.Label>
                    <i className="fa-brands fs-2 me-2 fa-cc-visa"></i>
                  </Form.Check.Label>
                </Form.Check>
                <Form.Check>
                  <Form.Check.Input />
                  <Form.Check.Label>
                    <i className="fa-brands fs-2 me-2 fa-paypal"></i>
                  </Form.Check.Label>
                </Form.Check>
                <Form.Check>
                  <Form.Check.Input />
                  <Form.Check.Label>
                    <i className="fa-brands fs-2 fa-cc-amex"></i>
                  </Form.Check.Label>
                </Form.Check>
              </Form>
            </div>

            <Form className="mt-3" onSubmit={handleSubmit(onSubmit)}>
              <Row className="mb-3">
                <div className="col-lg-11 col-12">
                  <Form.Label className="text-start">Card Number</Form.Label>
                  <input
                    type="text"
                    className="inputCard col-lg-12 col-12 p-2"
                    {...register("cardNumber", { required: true })}
                  />
                  {errors.cardNumber && (
                    <span className="text-danger text-start">
                      This field is required
                    </span>
                  )}
                </div>
              </Row>
              <Row>
                <div className=" col-lg-6 col-12 pb-3">
                  <div className="d-flex flex-column">
                    <Form.Label className="text-start">Expires</Form.Label>
                    <input
                      type="date"
                      className="inputCard col-lg-6 col-12 p-2"
                      {...register("expireDate", { required: true })}
                    />
                    {errors.expireDate && (
                      <span className="text-danger text-start">
                        This field is required
                      </span>
                    )}
                  </div>
                </div>

                <div className=" col-lg-6 col-12">
                  <div className="d-flex flex-column ">
                    <Form.Label className="text-start">
                      Security code
                    </Form.Label>
                    <input
                      type="text"
                      maxLength={3}
                      className="inputCard col-lg-6 col-12 p-2"
                      {...register("expireDate", { required: true })}
                    />
                    {errors.expireDate && (
                      <span className="text-danger text-start">
                        This field is required
                      </span>
                    )}
                  </div>
                </div>
              </Row>

              <Form.Group className="mb-3" id="formGridCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Agree terms and conditions"
                />
              </Form.Group>

              <Button
                className="border-0"
                style={{ backgroundColor: "#7cb600" }}
                type="submit"
              >
                Complete Purchase
              </Button>
            </Form>
            {loader === true && (
              <div className="d-flex flex-column justify-content-center align-items-center mt-4">
                <img
                  src="https://cdn.discordapp.com/attachments/834507024796614656/994717240098291722/cup2.gif"
                  className="cupImage"
                />
                <p className="text-center fw-bold text-secondary">
                  Processing payment...
                </p>
              </div>
            )}
          </div>

          {newOrder && loader === false ? (
            <OrderModal
              newOrder={newOrder}
              setNewOrder={setNewOrder}
              show={true}
              setShow={setShow}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}

export default Checkout;
